<template lang="html">
  <div class="catalog-section grid">
    <div class="catalog-section__left relative h-50 md:h-75 xl:h-100">
      <!-- Баннер — LCP главной, каждый вариант на своём вьюпорте.
      display:none не отменяет загрузку скрытого варианта, поэтому sizes
      сужает невидимую версию до минимального srcset-кандидата -->
      <UiPicture
        src="catalog/brand/mainBanner.png"
        provider="ipx"
        variant="imageFull"
        alt="Главный баннер магазина"
        sizes="2400px md:100vw"
        fetchpriority="high"
        class="max-2xl:[&>img]:object-center"
      />
    </div>
  </div>
</template>

<script setup lang="ts">
import UiPicture from '~/app/components/Image/UiPicture.vue'
</script>
